"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _actions = require("./actions");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledArrowButton = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: rgba(255, 255, 255, 0.75);\n  width: 56px;\n  height: 56px;\n  padding: 0;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:disabled > span {\n    color: rgba(255, 255, 255, 0.2);\n  }\n\n  & > span {\n    font-size: 32px;\n  }\n"])));

var Wrapper = function Wrapper(_ref) {
  var isLeft = _ref.isLeft,
      getLeaderboard = _ref.getLeaderboard,
      setBetbarParent = _ref.setBetbarParent,
      betbarParent = _ref.betbarParent;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickem = _useSelector.activePickem,
      activePickemList = _useSelector.activePickemList,
      isBetbarLoading = _useSelector.isBetbarLoading;

  var indexOfActivePickem = activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.findIndex(function (obj) {
    return obj.id === (activePickem === null || activePickem === void 0 ? void 0 : activePickem.id);
  });
  var isDisabled = (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) === 1 || isLeft ? indexOfActivePickem === (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) - 1 : indexOfActivePickem === 0;

  var handleArrowClicked = function handleArrowClicked() {
    var _pickem, _pickem2, _pickem3, _pickem4, _pickem5;

    window.scrollTo(0, 0);
    var pickem;

    if (isLeft) {
      pickem = activePickemList[indexOfActivePickem + 1];
    } else {
      pickem = activePickemList[indexOfActivePickem - 1];
    }

    dispatch((0, _actions.setBetbar)({
      activePickem: pickem,
      activeBet: (_pickem = pickem) === null || _pickem === void 0 ? void 0 : _pickem.activeBet,
      isActivePickemInPlay: ((_pickem2 = pickem) === null || _pickem2 === void 0 ? void 0 : _pickem2.status) === "IN_PLAY",
      isActivePickemCompleted: ((_pickem3 = pickem) === null || _pickem3 === void 0 ? void 0 : _pickem3.status) === "COMPLETED",
      isActivePickemApproved: ((_pickem4 = pickem) === null || _pickem4 === void 0 ? void 0 : _pickem4.status) === "APPROVED",
      hadBet: (_pickem5 = pickem) !== null && _pickem5 !== void 0 && _pickem5.activeBet ? true : false
    }, setBetbarParent));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledArrowButton, {
    disabled: isDisabled || isBetbarLoading,
    onClick: handleArrowClicked,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
      children: isLeft ? "chevron_left" : "chevron_right"
    })
  });
};

var _default = Wrapper;
exports.default = _default;